import { useDispatch } from "react-redux";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import cn from "classnames";
import queryString from "query-string";

import { actions as authActions } from "../../actions/auth";
import { getSafeReturnPath } from "../../helpers";
import { ReactComponent as Logo } from "../../media/icons/mainLogo.svg";
import { Button } from "../common/button";
import { OverlayPreloader } from "../common/preloader";
import { Notification } from "../common/notification";
import styles from "./login.module.css";

export const Login = ({ errors, isLoggedIn, navigate, preloaders, user, keycloak }) => {
  const [notes, setNotes] = useState({ login: null });
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const setError = useCallback(() => dispatch(authActions.setError("failLogin", "")), [dispatch]);
  const returnPath = useMemo(() => getSafeReturnPath(queryString.parse(location.search).return), [location.search]);
  const keycloakRedirectUri = `${window.location.origin}${returnPath}`;

  useEffect(() => {
    document.title = t("dashboard_login_metatitle");
    if (isLoggedIn) {
      navigate(returnPath, { replace: true });
    }
  }, [isLoggedIn, navigate, returnPath, t]);

  useEffect(() => {
    if (errors.login) {
      setNotes({ login: errors.login });
      setTimeout(() => setNotes({ login: false }), 6000);
    }
  }, [errors]);

  useEffect(() => {
    if (user?.email) {
      navigate(returnPath, { replace: true });
    }
  }, [user?.email, navigate, returnPath]);

  return (
    <div className={styles.wrapper}>
      {preloaders.login && <OverlayPreloader overlayClassName={styles.overlay} />}

      {notes.login && (
        <Notification error>
          {notes.login.map((error, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <span key={index.toString()}>{error}</span>
          ))}
        </Notification>
      )}

      {errors.failLogin && (
        <Notification error close={setError}>
          {errors.failLogin}
        </Notification>
      )}

      <div className={styles.leftSide}>
        <div className={styles.header}>
          <Logo className={styles.mainLogo} title={t("dashboard_login_h1")} />
        </div>

        <div className={styles.content}>
          <Logo className={styles.logo} title={t("dashboard_login_h1")} />

          <Button className={styles.loginButton} type="button" onClick={() => keycloak.login({ redirectUri: keycloakRedirectUri })}>
            {t("dashboard_login_button")}
          </Button>

          <button
            type="button"
            onClick={() => keycloak.login({ redirectUri: keycloakRedirectUri, action: "register" })}
            className={cn("button", styles.createAccountButton)}
          >
            {t("dashboard_login_createaccount")}
          </button>
        </div>
      </div>

      <div className={styles.rightSide}>
        <img src="https://heritageweb.com/cdn-cgi/imagedelivery/n12z2FIWKA5iB6vfvG4ygw/5aad4529-c56e-4ec9-75b6-0be252f64800/full" alt="" />
      </div>
    </div>
  );
};
